import { Component, Input } from '@angular/core';

@Component({
  selector: 'itl-desktop-detail-view',
  templateUrl: './desktop-detail-view.component.html',
  styleUrls: ['./desktop-detail-view.component.scss'],
})
export class DesktopDetailViewComponent {
  @Input() showWhiteHeaderBackground: boolean;
}
